import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/services";

export function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-20 sm:py-28 bg-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="label-eyebrow">Patient Stories</p>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-medium tracking-tight text-brand-navy text-balance">
            Trusted by thousands of families in Lucknow
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />)}</div>
            <span className="text-sm font-semibold text-brand-navy">4.9 · Google Reviews</span>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure data-testid={`testimonial-${i}`} className="h-full rounded-2xl border border-border bg-brand-mist p-7 flex flex-col">
                <Quote className="h-8 w-8 text-brand/25" />
                <blockquote className="mt-3 text-[15px] leading-relaxed text-brand-navy/80 flex-1">"{t.text}"</blockquote>
                <div className="mt-5 flex">{[...Array(t.rating)].map((_, s) => <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />)}</div>
                <figcaption className="mt-4 flex items-center gap-3">
                  <img src={t.image} alt={t.name} className="h-11 w-11 rounded-full object-cover" />
                  <div>
                    <p className="font-semibold text-brand-navy text-sm">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.area}, Lucknow</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
